// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { deleteAccountUser } from 'services/AccountService'
import { logSentryError } from 'utils/sentry'

export const useDeleteTeamMemberMutation = () => {
  return useMutation({
    mutationFn: deleteAccountUser,
    onError(error: { status: number; message?: string; errorList: unknown }) {
      logSentryError('Error from TeamMemberDelete - deleteUser', error)
    },
  })
}
